<template>
	<v-container class="mt-4 ml-2" fluid>
		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard">

					<!-- Titulo -->
					<v-card-title primary-title>
						<span class="text-subtitle-1"><v-icon left>mdi-fingerprint</v-icon>Mi Nómina</span>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							dark
							@click="initialize()"
							small
							tile
						>
							Actualizar
						</v-btn>
					</v-card-title>

					<!-- FILTROS -->
					<v-card-text>
						<v-row>
							<v-col cols="12" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  hide-details
                  item-text="ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>

				      <v-col cols="12" md="3" lg="2">
				      	<v-select
					      	:items="semanasCiclo"
					      	v-model="selectedHeaders"
					      	label="# Semana"
					      	filled
                  dense
					      	hide-details
					      	item-text="bloque"
					      	item-value="value"
					      	:disabled="!semanasCiclo.length"
				      	></v-select>
				      </v-col>
						</v-row>
						<br />
	          <v-row>

              <v-col cols="12" v-if="!liberada">
                <v-alert
                  prominent
                  border="left"
                  colored-border
                  type="warning"
                  icon="mdi-lock-clock-outline"
                  class="mb-0"
                >
                  <div class="text-subtitle-1 font-weight-bold black--text">Nómina no disponible</div>
                  <div class="black--text mt-1">
                    La nómina de esta semana aún no ha sido liberada. Cuando RRHH la publique, podrás consultarla aquí.
                  </div>
                </v-alert>
              </v-col>

	          	<v-col cols="12" v-if="liberada && esNominaHistorial">
		          	<v-alert
						      prominent
						      border="left"
						      colored-border
						      type="info"
						      icon="mdi-history"
						      class="mb-0"
						    >
						      <div class="text-subtitle-1 font-weight-bold black--text">Nómina histórica</div>
						      <div class="black--text mt-1">
						        Estás viendo una semana ya cerrada. Solo aparecen los montos finales que quedaron registrados.
						      </div>
						      <ul class="black--text mb-0 mt-2 pl-4">
						        <li>Los botones <strong>Detalle</strong> están deshabilitados: no hay desglose de esa semana.</li>
						        <li>No se muestran horarios, asistencias ni fórmulas de cálculo.</li>
						      </ul>
						    </v-alert>
	          	</v-col>

	          	<v-col cols="12" v-if="liberada && !esNominaHistorial">
		          	<v-alert
						      outlined
						      type="info"
						      prominent
						      border="left"
						      icon="mdi-information-outline"
						      class="mb-0"
						    >
						      <div class="black--text">
						        Hola, {{ getdatosUsuarioERPERP.nombre_completo }}.
						        Para ver el desglose de cada concepto, da clic en
						        <v-chip color="blue" dark small class="mx-1">Detalle</v-chip>
						        en la tabla.
						      </div>
						    </v-alert>
	          	</v-col>


	          	<v-col cols="12">
	          		<v-data-table
	          			v-if="liberada"
	            		:headers="headers"
	            		:items="filterEntradas"
	            		class="elevation-0"
	            		:search="search"
	            		:page.sync="page"
	            		@page-count="pageCount = $event"
	            		:mobile-breakpoint="100"
	            		dense
	           		item-key="id"
	          		>
	            		<!-- Valores que ocupan botons, chips, iconos, etc -->
	            		<template v-slot:item.tipo_pago="{ item }">
	            			<v-chip v-if="item.tipo_pago == 2" small color="green" dark >Hora</v-chip>
	            			<v-chip v-if="item.tipo_pago == 1" small color="blue" dark >Dia</v-chip>
	            			<v-chip v-if="item.tipo_pago == null || item.tipo_pago == 0" small color="orange" dark >Sin Tipo Pago</v-chip>
	            		</template>

	            		<template v-slot:item.confirmacion_comisiones="{ item }">
	            			<v-chip v-if="(item.confirmacion_comisiones == 3)" small color="green" dark >Aceptadas</v-chip>
	            			<v-chip v-if="(item.confirmacion_comisiones == 4)" small color="blue" dark >Rechazadas</v-chip>
	            			<v-chip v-if="item.puesto == 'ENCARGADA DE SUCURSAL' && (item.confirmacion_comisiones == null || item.tipo_pago == 0)" small color="orange" dark >Pendiente</v-chip>
	            		</template>

	            		<template v-slot:item.monto_laborado="{ item }">
	            			{{ item.monto_laborado }}
	            			<v-chip
	            				right
	            				class="ml-2"
	            				small
	            				:color="esRegistroHistorial(item) ? 'grey lighten-3' : 'blue'"
	            				:dark="!esRegistroHistorial(item)"
	            				:disabled="esRegistroHistorial(item)"
	            				@click="abrirDetalleMontoLaborado(item)"
	            			>Detalle</v-chip>
	            		</template>

	            		<template v-slot:item.monto_horas_extras="{ item }">
	            			{{ item.monto_horas_extras }}
	            			<v-chip
	            				right
	            				class="ml-2"
	            				small
	            				:color="esRegistroHistorial(item) ? 'grey lighten-3' : 'blue'"
	            				:dark="!esRegistroHistorial(item)"
	            				:disabled="esRegistroHistorial(item)"
	            				@click="abrirDetalleHorasExtras(item)"
	            			>Detalle</v-chip>
	            		</template>

	            		<template v-slot:item.comisiones_semana="{ item }">
	            			{{ item.comisiones_semana }}
	            			<v-chip
	            				right
	            				class="ml-2"
	            				small
	            				:color="esRegistroHistorial(item) ? 'grey lighten-3' : 'blue'"
	            				:dark="!esRegistroHistorial(item)"
	            				:disabled="esRegistroHistorial(item)"
	            				@click="abrirDetalleComisiones(item)"
	            			>Detalle</v-chip>
	            		</template>

	            		<template v-slot:item.monto_total_rebajes="{ item }">
	            			{{ item.monto_total_rebajes }}
	            			<v-chip
	            				right
	            				class="ml-2"
	            				small
	            				:color="esRegistroHistorial(item) ? 'grey lighten-3' : 'blue'"
	            				:dark="!esRegistroHistorial(item)"
	            				:disabled="esRegistroHistorial(item)"
	            				@click="abrirDetalleRebajes(item)"
	            			>Detalle</v-chip>
	            		</template>

	            		<template v-slot:item.monto_total_bonos="{ item }">
	            			{{ item.monto_total_bonos }}
	            			<v-chip
	            				right
	            				class="ml-2"
	            				small
	            				color="blue"
	            				dark
	            				@click="abrirDetalleBonos(item)"
	            			>Detalle</v-chip>
	            		</template>

	            		<template v-slot:item.monto_total="{ item }">
	            			{{ item.monto_total }}
	            		</template>

	            		<template v-slot:item.asistencias="{ item }">
	            			<v-icon
		            			v-if="!esRegistroHistorial(item)"
		            			small
		            			class="mr-2"
		            			color="blue"
		            			@click="mostrarAsistencias(item)"
		            			>
		            			mdi-file-document
		            		</v-icon>
	            		</template>

		            	<template v-slot:no-data>
		            		<v-btn
			            		color="primary"
			            		@click="initialize"
			            		small
		            		>
		            		Actualizar
		            		</v-btn>
		            	</template>
		          	</v-data-table>

						    <div v-if="liberada && tieneDetalleHorario()" class="black--text">
						    	<v-row>
						    		<v-col cols="12" md="8" lg="4">
						    			<v-card outlined>
						    				<v-card-text class="black--text">
					        				<b>Día de descanso: </b>{{ getDiaDescansoTexto() }}
					        				<br/>
					        				<b>Horario fin de semana: </b>{{ getHorarioEntrada(0) }} a {{ getHorarioSalida(0) }}
					        				<br/>
					        				<b>Horario entre semana: </b>{{ getHorarioEntrada(4) }} a {{ getHorarioSalida(4) }}
						    				</v-card-text>
						    			</v-card>
						    		</v-col>
						    	</v-row>
						    </div>

						    <br v-if="liberada && tieneDetalleHorario()"/>
						    <br v-if="liberada && tieneDetalleHorario()"/>

						    <v-alert
						    	v-if="liberada && estatus_nomina == 1"
						      prominent
						      border="left"
						      colored-border
						      type="success"
						      icon="mdi-check-circle-outline"
						      class="mb-3"
						    >
						      <div class="text-subtitle-1 font-weight-bold">Nómina aceptada</div>
						      <div class="mt-1">Tu nómina fue aceptada correctamente.</div>
						    </v-alert>

						    <v-alert
						    	v-if="liberada && estatus_nomina == 2"
						      prominent
						      border="left"
						      colored-border
						      type="error"
						      icon="mdi-alert-circle-outline"
						      class="mb-3"
						    >
						      <div class="text-subtitle-1 font-weight-bold">Nómina en revisión</div>
						      <div class="mt-1">Recibimos tu rechazo. Operaciones lo está revisando; podrás consultarla de nuevo cuando se actualice.</div>
						    </v-alert>

						    
						    <v-btn 
						    	v-if="liberada && !esNominaHistorial && !rechazado && ![1,2].includes( estatus_nomina )"
						    	color="success"
						    	dark
						    	tile
						    	class="mr-2"
						    	@click="dialogAceptar = true"
						    >
						  		Aceptar
						  		<v-icon small right>mdi-check</v-icon>
						  	</v-btn>


						  	<v-btn 
						  		v-if="liberada && !esNominaHistorial && !rechazado && ![1,2].includes( estatus_nomina )"
						    	color="red darken-3"
						    	dark
						    	tile
						    	@click="rechazado = true"
						    >
						  		Rechazar
						  		<v-icon small right>mdi-close</v-icon>
						  	</v-btn>
	        		</v-col>

	        		<v-col cols="12" md="6" lg="4" v-if="liberada && rechazado">
	        			<v-textarea
	        				v-model="motivo"
	        				:rows="3"
	        				auto-grow
	        				filled
	        				dense
	        				label="Agrega tu motivo por favor"
	        			>
	        			</v-textarea>
						  	
						  	<v-btn 
						    	color="black"
						    	dark
						    	tile
						    	class="mr-2"
						    	@click="rechazado = false"
						    >
						  		Cancelar
						  		<v-icon small right>mdi-close</v-icon>
						  	</v-btn>

	        			<v-btn 
						    	color="success"
						    	dark
						    	tile
						    	class="mr-2"
						    	@click="save(2)"
						    >
						  		Aceptar
						  		<v-icon small right>mdi-check</v-icon>
						  	</v-btn>


	        		</v-col>

	        		<v-col cols="12" md="6">
		        		<v-row>
						  		<v-col cols="12"
						  			v-for="(mensaje, i) in comentarios" :key="i"
						  		>
								  	<p 
								  		:class="`pa-2 ma-0 mb-4 ${ mensaje.id_usuario != getdatosUsuarioERPERP.id_trabajador ? 'mensajeIzq' : 'mensajeDer' }`">
								    	{{ mensaje.comentarios }}
								    	<br/>
								    	{{ mensaje.nombre_completo }}
								  	</p>
						  		</v-col>
						  	</v-row>
	        		</v-col>

	      		</v-row>
		    	</v-card-text>
				</v-card> 
			</v-col>
			<v-dialog v-model="dialogAceptar" max-width="500px">
				<v-card>
					<v-card-text class="text-h6 black--text">
						¿Estás seguro que deseas guardar la nómina?
					</v-card-text>
					<v-card-actions class="pt-6">
						<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
						<v-btn
							color="black"
							small
							tile
							dark
							class="mr-2"
							@click="dialogAceptar=false"
						>
							No, cancelar
							<v-icon small right>mdi-cancel</v-icon>
						</v-btn>
						<v-spacer></v-spacer>
						<!-- Guardar la información  -->
						<v-btn
							color="green"
							small
							dark
							tile
							@click="dialogAceptar = false, save( 1 )"
						>
							Si
							<v-icon small right>mdi-content-save</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--Dialogs de Formulas de Montos -->
			<v-dialog
				v-model="dialogMontoLaborado"
				hide-overlay
				persistent
				max-width="500"
			>
				<v-card>
					<v-card-title class="text-h5">
						Desglose Monto Jornada Laboral
					</v-card-title>
					<v-card-text>
						<v-textarea
							v-model="formula_monto_laborado"
							rows="3"
							auto-grow
							label="Sueldo Diario  X  Cantidad Dias Laborados"
							filled
							hide-details
							readonly
						/>
					</v-card-text>
					<v-card-actions>
						<v-btn
							color="black"
							tile
							dark
							small
							@click="dialogMontoLaborado = false"
						>
							<v-icon small left>mdi-cancel</v-icon>
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogHorasExtras"
				hide-overlay
				persistent
				max-width="500"
			>
				<v-card>
					<v-card-title class="text-h5">
						Desglose Monto Horas Extras
					</v-card-title>
					<v-card-text>
						<v-textarea
							v-model="formula_horas_extras"
							rows="3"
							auto-grow
							label="Sueldo Hora  X  Cantidad Horas Extras"
							filled
							hide-details
							readonly
						/>
					</v-card-text>
					<v-card-actions>
						<v-btn
							color="black"
							tile
							dark
							small
							@click="dialogHorasExtras = false"
						>
							<v-icon small left>mdi-cancel</v-icon>
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogMontoRebajes"
				hide-overlay
				persistent
				max-width="520"
			>
				<v-card>
					<v-card-title class="text-h6 py-3">
						<v-icon left color="primary">mdi-cash-minus</v-icon>
						Desglose Monto Rebajes
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-list dense class="py-0">
							<div v-for="(concepto, i) in rebajesDetalleItems" :key="'c-' + i">
								<v-list-item class="px-0" :class="{ 'align-start': (concepto.subItems && concepto.subItems.length) || (concepto.detalleItems && concepto.detalleItems.length) }">
									<v-list-item-icon class="mr-3 mt-1">
										<v-icon :color="concepto.iconColor" small>{{ concepto.icon }}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<div class="d-flex align-center">
											<v-list-item-title class="text-body-2 font-weight-medium">{{ concepto.label }}</v-list-item-title>
											<v-btn
												v-if="(concepto.detalleItems && concepto.detalleItems.length) || (concepto.subItems && concepto.subItems.length)"
												x-small
												text
												class="ml-2"
												@click="toggleRebajeDetalle(concepto.id)"
											>
												<v-icon x-small>{{ rebajesExpandidos[concepto.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
												<span class="text-caption ml-1">{{ rebajesExpandidos[concepto.id] ? 'Ocultar' : 'Ver detalle' }}</span>
											</v-btn>
										</div>
										<div v-if="concepto.subItems && concepto.subItems.length && rebajesExpandidos[concepto.id]" class="ml-2 mt-2">
											<div v-for="(sub, j) in concepto.subItems" :key="j" class="d-flex align-center text-caption mb-1 grey--text text--darken-1">
												<v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
												<span>{{ sub.fecha }}: {{ sub.entrada }}</span>
											</div>
										</div>
										<div v-if="concepto.detalleItems && concepto.detalleItems.length && rebajesExpandidos[concepto.id]" class="ml-2 mt-2">
											<div v-for="(d, j) in concepto.detalleItems" :key="j" class="text-caption mb-2 pa-2 grey lighten-4 rounded">
												<div v-if="d && typeof d === 'object'">
													<div v-if="(d.cantidad != null && d.cantidad !== '') || (d.Cantidad != null && d.Cantidad !== '')" class="d-flex align-center mb-1">
														<span class="font-weight-medium mr-1">Cantidad:</span>
														<span>$ {{ formatMonto(d.cantidad || d.Cantidad) }}</span>
													</div>
													<div v-if="(d.comentario != null && d.comentario !== '') || (d.Comentario != null && d.Comentario !== '')" class="d-flex align-center mb-1">
														<span class="font-weight-medium mr-1">Comentario:</span>
														<span>{{ d.comentario || d.Comentario }}</span>
													</div>
												</div>
												<div v-else>{{ d }}</div>
											</div>
										</div>
									</v-list-item-content>
									<v-list-item-action class="ml-2">
										<span class="text-subtitle-2 font-weight-bold primary--text">$ {{ concepto.valor }}</span>
									</v-list-item-action>
								</v-list-item>
								<v-divider v-if="i < rebajesDetalleItems.length - 1" class="my-2"></v-divider>
							</div>
						</v-list>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-4">
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							tile
							dark
							small
							@click="dialogMontoRebajes = false"
						>
							<v-icon small left>mdi-close</v-icon>
							Cerrar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogComisiones"
				hide-overlay
				persistent
				max-width="1200"
			>
				<v-card>
					<v-card-title class="text-h5">
						Desglose Monto Comisiones
					</v-card-title>
					<v-card-text>

						<v-row align="center" class="no-gutters">
              <v-col cols="12" md="6" lg="4">
                <span class="black--text text-h8"
                  ><b>Total Comisiones:</b>
                  {{ totalComisiones }} 
                </span>
              </v-col>
            </v-row>
            <v-row align="center" class="no-gutters">
              <v-col cols="12" md="6" lg="4">
                <span class="black--text text-h8"
                  ><b>Cantidad Comisiones:</b>
                  {{ cantidadComisiones }} 
                </span>
              </v-col>
            </v-row>

						<v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersComisiones"
                  :items="encargadascomisiones"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  dense
                >
                </v-data-table>
              </v-col>
            </v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn
							color="black"
							tile
							dark
							small
							@click="dialogComisiones = false"
						>
							<v-icon small left>mdi-cancel</v-icon>
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogMontoBonos"
				hide-overlay
				persistent
				max-width="520"
			>
				<v-card>
					<v-card-title class="text-h6 py-3">
						<v-icon left color="primary">mdi-cash-plus</v-icon>
						Desglose Monto Bonos
						<v-spacer></v-spacer>
						<v-btn icon small @click="dialogMontoBonos = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<div class="caption grey--text text--darken-1 mb-3">
							Ventas + RI + Puntualidad + Prima Vacacional + Compensaciones
						</div>
						<v-list dense class="py-0">
							<div v-for="(concepto, i) in bonosDetalleItems" :key="'b-' + i">
								<v-list-item class="px-0">
									<v-list-item-icon class="mr-3 my-0 align-self-center">
										<v-icon :color="concepto.iconColor" small>{{ concepto.icon }}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="text-body-2 font-weight-medium">
											{{ concepto.label }}
										</v-list-item-title>
										<v-list-item-subtitle v-if="concepto.hint" class="caption">
											{{ concepto.hint }}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action class="ml-2 my-0 align-self-center">
										<span
											class="text-subtitle-2 font-weight-bold"
											:class="concepto.esTotal ? 'success--text' : 'primary--text'"
										>
											{{ formatMoneyBonos(concepto.valor) }}
										</span>
									</v-list-item-action>
								</v-list-item>
								<v-divider v-if="i < bonosDetalleItems.length - 1" class="my-2"></v-divider>
							</div>
						</v-list>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-4">
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							tile
							dark
							small
							@click="dialogMontoBonos = false"
						>
							<v-icon small left>mdi-close</v-icon>
							Cerrar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>


			<v-dialog
				v-model="dialogMontoTotal"
				hide-overlay
				persistent
				max-width="500"
			>
				<v-card>
					<v-card-title class="text-h5">
						Desglose Monto Total
					</v-card-title>
					<v-card-text>
						<v-textarea
							v-model="formula_monto_total"
							rows="3"
							auto-grow
							label="(Monto Jornada Laboral + Monto Compensaciones + Monto Horas Extras + Monto Comisiones + Monto Bonos) - Monto Rebajes"
							filled
							hide-details
							readonly
						/>
					</v-card-text>
					<v-card-actions>
						<v-btn
							color="black"
							tile
							dark
							small
							@click="dialogMontoTotal = false"
						>
							<v-icon small left>mdi-cancel</v-icon>
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>

</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';

	import botonesRoles          from '@/components/roles/botonesRoles.vue';

	import validarErrores  from '@/mixins/validarErrores'
	import XLSX            from 'xlsx'
	import funcionesExcel  from '@/mixins/funcionesExcel'


	export default {
		components:{
			Alerta,
			carga,
			botonesRoles,
		},

		mixins: [ validarErrores, funcionesExcel ],

		data: () => ({
    	// Alertas
			parametros:{
				dialogError: false,
				mensaje: '',
				color: ''
			},

			respuestaAlerta:false,
			loader: true,
			cargar: false,

			encabezados: null,
			encabezados2: null,
			dialogAceptar: false,
			dialogActualizar: false,
			dialogAsistencias: false,
			dialogMontoLaborado: false,
			dialogHorasExtras: false,
			dialogMontoRebajes: false,
			dialogMontoBonos: false,
			bonosDetalleItems: [],
			dialogMontoTotal: false,
			ciclos:[],
			gruposRoles: [],
			pagos: [],
			ciclo:null,
			id_ciclo: 0,

      // Filtros: 
			fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      // tabla
			search:'',
			search2:'',
			formula_monto_laborado:'',
			formula_horas_extras:'',
			formula_monto_rebajes:'',
			rebajesDetalleItems: [],
			rebajesExpandidos: {},
			formula_monto_bonos:'',
			formula_monto_total:'',
			page: 1,
			page2: 1,
			pageCount: 0,
			itemsPerPage: 10,
			entradassalidas: [],
			nomina_pasada: [],
			nominaSemanal: [],
			autorizarNomina: [],
			nominaEstatus: [],
			nominaTeachersSabatino: [],
			nominaTeachersCatorcena: [],
			asistencias: [],
			estatus: null,
			entradassalidasteachers: [],
			horasDobles:[],
			horasTotales: 0,
			headers: [
        // { text: 'ID'                    , value: 'id'                   },
				// { text: 'Empleado'              , value: 'nombre_completo'      },
				// { text: 'Puesto'                , value: 'puesto'               },
				{ text: 'Monto Jornada Laboral' , value: 'monto_laborado'       },
				{ text: 'Monto Horas Extras'    , value: 'monto_horas_extras'   },
				{ text: 'Monto Comisiones'      , value: 'comisiones_semana'    },
				{ text: 'Monto Rebajes'         , value: 'monto_total_rebajes'  },
				{ text: 'Monto Bonos'           , value: 'monto_total_bonos'    },
				{ text: 'Monto Total'           , value: 'monto_total'          },
				// { text: 'Departamento'          , value: 'departamento'         },
		    // { text: 'Plantel'               , value: 'plantel'              },
				// { text: 'Tipo pago'             , value: 'tipo_pago'            },
				// { text: 'Sueldo mensual'        , value: 'sueldo_mensual'       },
				// { text: 'Sueldo semanal'        , value: 'sueldo_semanal'       },
				// { text: 'Sueldo diario'         , value: 'sueldo_dia'           },
				// { text: 'Sueldo hora'           , value: 'sueldo_hora'          },
				// { text: 'Horas laborales'       , value: 'horas_laborales'      },
				// { text: 'Dias Laborados'        , value: 'dia_laboral'          },
		    // { text: 'Horas Extras'          , value: 'cantidad_horas'       },
				// { text: 'Monto Horas Extras'    , value: 'monto_horas_extras'   },
				// { text: 'Retardos'              , value: 'retardos'             },
				// { text: 'Comisiones'            , value: 'comisiones_semana'    },
				// { text: 'Devoluciones'          , value: 'devoluciones'         },
				// { text: 'Rebajes'               , value: 'rebajes'              },
				// { text: 'Monto Retardo'         , value: 'monto_retardo'        },
				// { text: 'Retenciones'           , value: 'retensiones'          },
        // { text: 'Compensaciones'        , value: 'compensaciones'       },
        // { text: 'Premios'               , value: 'premios'              },
				// { text: 'Bonos Ventas'          , value: 'bonos_ventas'         },
        // { text: 'Bonos RI'              , value: 'bonos_ri'             },
				// { text: 'Bonos Puntualidad'     , value: 'bonos_puntualidad'    },
				// { text: 'Seguro IMSS'           , value: 'seguroIMSS'           },
				// { text: 'Caja de Ahorro'        , value: 'cajaAhorro'           },
				// { text: 'Monto Jornada Laboral' , value: 'monto_laborado'       },
				// { text: 'Monto Total'           , value: 'monto_total'          },
				// { text: 'Monto Compensaciones'  , value: 'compensaciones'       },
			],
			headerscomparativa: [
				{ text: 'ID'                     , value: 'id_trabajador'         },
				{ text: 'Empleado'               , value: 'empleado'              },
				{ text: 'Puesto'                 , value: 'puesto'                },
				{ text: 'Departamento'           , value: 'departamento'          },
				{ text: 'Plantel'                , value: 'plantel'               },
				{ text: 'Monto Total Anterior'   , value: 'monto_total'           },
				{ text: 'Monto Total Actual'     , value: 'monto_total_actual'    },
				{ text: 'Monto Total Diferencia' , value: 'monto_total_diferencia'},
				],
			headersAsistencias: [
				{ text: "Hora Entrada"    , value: "hora_entrada"    },
				{ text: "Hora Salida"     , value: "hora_salida"     },
				{ text: "Chequeo Entrada" , value: "chequeo_entrada" },
				{ text: "Chequeo Salida"  , value: "chequeo_salida"  },
				{ text: "¿Regular?"       , value: "hora_regular"    },
				{ text: "Horas Extras"    , value: "hora_extra"      },
				{ text: "Horas Negativas" , value: "hora_negativa"   },
				{ text: "Horas Trabajo"   , value: "hora_trabajo"    },
				{ text: "Horas Trabajadas", value: "hora_trabajada"  },
				{ text: "Aceptar"         , value: "aceptar"         },
				],
			gruposRoles2:[],
			encargadascomisiones:[],
			headersComisiones: [
	      // { text: "ID", value: "id_alumno" },
	      { text: "Matrícula", value: "matricula" },
	      { text: "Alumno"   , value: "alumno"    },
	      { text: "Grupo"    , value: "grupo"     },
	      // { text: "Precio Grupo", value: "precio_grupo" },
	      // { text: "Precio con Descuento", value: "precio_grupo_con_descuento_x_alumno" },
	      // { text: "Monto Pagado", value: "pagado" },
	      // { text: "Fecha", value: "fecha_pago" },
	      // { text: "Fecha Ultimo Cambio", value: "fecha_ultimo_cambio" },
	      // { text: "Comisionista", value: "vendedora" },
	      { text: "Comisión", value: "comision"   },
	    ],

	    dialogComisiones: false,
			selectedHeaders:null,
			semanasCiclo: [],
			_configurandoFiltros: false,
			liberada: false,
			motivo: '',
			rechazado:false,

			estatus_nomina: 0,
			comentarios:[],
		}),

		watch:{
			ciclo( value, oldValue ){
				if( !value || this._configurandoFiltros ) return
				if( oldValue && oldValue.id_ciclo !== value.id_ciclo ){
					this.actualizarSemanas()
				}
			},
			selectedHeaders( value, oldValue ){
				if( !value || this._configurandoFiltros ) return
				if( value !== oldValue ) this.initialize()
			}
		},

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			filterTeacher( ){
				let teachers = this.entradassalidasteachers;
				return teachers.filter(el => el.puesto === 'Teacher');
			},

			filterEntradas( ){
				let entradass = this.entradassalidas.concat(this.nominaTeachersSabatino, this.nominaTeachersCatorcena);
				return entradass.filter(el =>  el.puesto !== 'Sin puesto');
			},

			filterEntradasEncargadas( ){
				let entradass = this.entradassalidas;
				return entradass.filter(el => el.puesto !== 'Sin puesto' && el.puesto == 'ENCARGADA DE SUCURSAL');
			},

			totalComisiones() {
	      let subtotal = this.encargadascomisiones
	        .map((item) => item.comision)
	        .reduce((prev, curr) => prev + curr, 0);
	      return new Intl.NumberFormat("en-US", {
	        style: "currency",
	        currency: "USD",
	      }).format(subtotal);
	    },
	    cantidadComisiones() {
	      let subtotal = this.encargadascomisiones.length;
	      this.cd1 = subtotal;
	      return Math.floor(subtotal);
	    },

			esNominaHistorial(){
				if( !this.entradassalidas.length ) return this.esSemanaPasada()
				return this.esSemanaPasada() || !!this.entradassalidas[0].desde_historial
			},

		},


		async created () {
			await Promise.all([
				this.cargarCiclos(),
				this.misComisiones(),
			])
		},

		methods: {
			esRegistroHistorial( item ){
				return item && item.desde_historial === true
			},

			abrirDetalleMontoLaborado( item ){
				if( this.esRegistroHistorial(item) ) return
				this.formulaMontoLaborado(item)
				this.dialogMontoLaborado = true
			},

			abrirDetalleHorasExtras( item ){
				if( this.esRegistroHistorial(item) ) return
				this.formulaMontoHorasExtras(item)
				this.dialogHorasExtras = true
			},

			abrirDetalleComisiones( item ){
				if( this.esRegistroHistorial(item) ) return
				this.dialogComisiones = true
			},

			abrirDetalleRebajes( item ){
				if( this.esRegistroHistorial(item) ) return
				this.formulaMontoRebajes(item)
				this.dialogMontoRebajes = true
			},

			abrirDetalleBonos( item ){
				this.formulaMontoBonos(item)
				this.dialogMontoBonos = true
			},

			parseMontoBonos(val) {
				if (val == null || val === '') return 0
				const n = parseFloat(String(val).replace(/[$,]/g, ''))
				return Number.isFinite(n) ? n : 0
			},

			formatMoneyBonos(val) {
				const n = this.parseMontoBonos(val)
				return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
			},

			tieneDetalleHorario(){
				const item = this.entradassalidas.length ? this.entradassalidas[0] : null
				if( !item || this.esRegistroHistorial(item) ) return false
				return item.hora_entrada && item.hora_entrada.length && item.hora_salida && item.hora_salida.length
			},

			getDiaDescansoTexto(){
				const item = this.entradassalidas.length ? this.entradassalidas[0] : null
				if( !item || item.dia_descanso == null || item.dia_descanso === undefined ) return 'NO CONFIGURADO'
				return this.getDiaDescando(item.dia_descanso)
			},

			getHorarioEntrada( indice ){
				const item = this.entradassalidas.length ? this.entradassalidas[0] : null
				if( !item || !item.hora_entrada || item.hora_entrada[indice] == null ) return ''
				return item.hora_entrada[indice]
			},

			getHorarioSalida( indice ){
				const item = this.entradassalidas.length ? this.entradassalidas[0] : null
				if( !item || !item.hora_salida || item.hora_salida[indice] == null ) return ''
				return item.hora_salida[indice]
			},

			calcularSemanasCiclo( ciclo ){
				if( !ciclo || !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo ) return []

				const parseDate = ( fecha ) => new Date(fecha.substr(0, 10) + 'T12:00:00')
				const formatDate = ( fecha ) => fecha.toISOString().substr(0, 10)

				const inicio = parseDate(ciclo.fecha_inicio_ciclo)
				const fin = parseDate(ciclo.fecha_fin_ciclo)
				const semanas = []
				let current = new Date(inicio)
				let num = 1

				while( current <= fin ){
					const weekStart = new Date(current)
					const weekEnd = new Date(current)
					weekEnd.setDate(weekEnd.getDate() + 6)
					if( weekEnd > fin ) weekEnd.setTime(fin.getTime())

					semanas.push({
						bloque: `Semana ${ num }`,
						value: num,
						fecha_inicio: formatDate(weekStart),
						fecha_fin: formatDate(weekEnd),
					})

					num++
					current.setDate(current.getDate() + 7)
				}

				this.etiquetarSemanasCiclo( semanas )
				return semanas
			},

			etiquetarSemanasCiclo( semanas ){
				const total = semanas.length
				if( total < 5 ) return

				for( let i = 0; i < total; i++ ){
					const num = i + 1
					if( num === 1 ){
						semanas[i].bloque = 'Semana 1'
					} else if( num === 2 ){
						semanas[i].bloque = 'Semana 2'
					} else if( num === total - 1 ){
						semanas[i].bloque = 'Semana 3'
					} else if( num === total ){
						semanas[i].bloque = 'Semana 4'
					} else {
						semanas[i].bloque = `Semana vacaciones ${ num - 2 }`
					}
				}
			},

			actualizarSemanas(){
				this.semanasCiclo = this.calcularSemanasCiclo(this.ciclo)

				if( !this.semanasCiclo.length ){
					this.selectedHeaders = null
					return
				}

				const semanaActual = this.semanasCiclo.find(
					el => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin
				)

				this.selectedHeaders = semanaActual
					? semanaActual.value
					: this.semanasCiclo[this.semanasCiclo.length - 1].value
			},

			getSemanaSeleccionada(){
				return this.semanasCiclo.find(el => el.value === this.selectedHeaders) || null
			},

			esSemanaPasada(){
				const semana = this.getSemanaSeleccionada()
				if( !semana ) return false
				return semana.fecha_fin < this.fecha
			},

			getFechaConsulta(){
				const semana = this.getSemanaSeleccionada()
				if( !semana ) return this.fecha

				if( this.esSemanaPasada() ) return semana.fecha_fin
				if( this.fecha >= semana.fecha_inicio && this.fecha <= semana.fecha_fin ) return this.fecha
				return semana.fecha_inicio
			},

			procesarEntradas( entradassalidas ){
				for( const i in entradassalidas ){

					const { bonos_ventas, bonos_ri, bonos_puntualidad, prima_vacacional, monto_total_bonos, compensaciones } = entradassalidas[i]

					let bono1 = bonos_ventas ? bonos_ventas.replace('$','').replace(',','') : 0
					let bono2 = bonos_ri ? bonos_ri.replace('$','').replace(',','') : 0
					let bono3 = bonos_puntualidad ? bonos_puntualidad.replace('$','').replace(',','') : 0
					let bonoPrima = prima_vacacional ? String(prima_vacacional).replace('$','').replace(',','') : 0
					let compensaciones2 = compensaciones ? compensaciones.replace('$','').replace(',','') : 0

					entradassalidas[i].monto_total_bonos = this.format(
						parseFloat(compensaciones2) + parseFloat(bono1) + parseFloat(bono2) + parseFloat(bono3) + parseFloat(bonoPrima)
					)
				}

				this.entradassalidas = entradassalidas

				if( this.entradassalidas.length ){
					this.estatus_nomina = this.entradassalidas[0].estatus_nomina
					this.comentarios = this.entradassalidas[0].comentarios || []
					this.comentarios = this.comentarios.filter(
						el => [356, this.getdatosUsuarioERPERP.id_trabajador, 1086].includes(el.id_usuario)
					)
				}else{
					this.estatus_nomina = 0
					this.comentarios = []
				}
			},

			initialize () {
				if( !this.ciclo || !this.selectedHeaders ) return

				this.cargar = true
				this.entradassalidas = []
				this.entradassalidasteachers = []

				const semana = this.getSemanaSeleccionada()
				const idTrabajador = this.getdatosUsuarioERPERP.id_trabajador

				if( this.esSemanaPasada() ){
					const payload = {
						id_ciclo: this.ciclo.id_ciclo,
						semana: this.selectedHeaders,
						id_trabajador: idTrabajador,
						fecha_inicio: semana.fecha_inicio,
						fecha_final: semana.fecha_fin,
					}

					return this.$http.post('usuarios.entradas.historial', payload).then(response=>{
						try{
							this.encabezados = response.data.encabezados
							this.liberada = response.data.liberada
							this.procesarEntradas(response.data.result3 || [])
						}catch( error ){
							console.log(error)
						}
					}).catch( error =>{
						this.validarError( error.response.data.message )
					}).finally( () => { this.cargar = false })
				}

				const payloadLiberada = {
					id_ciclo: this.ciclo.id_ciclo,
					semana: this.selectedHeaders,
				}

				return this.$http.post('usuarios.nomina.liberada', payloadLiberada).then(response=>{
					this.liberada = response.data.liberada

					if( !this.liberada ){
						this.estatus_nomina = 0
						this.comentarios = []
						return Promise.resolve()
					}

					const payload = {
						fecha: this.getFechaConsulta(),
						id_ciclo: this.ciclo.id_ciclo,
						semana: this.selectedHeaders,
						id_trabajador: idTrabajador,
					}

					return this.$http.post('usuarios.entradas', payload).then(responseEntradas=>{
						try{
							this.encabezados = responseEntradas.data.encabezados
							this.liberada = responseEntradas.data.liberada
							this.procesarEntradas(responseEntradas.data.result3 || [])
						}catch( error ){
							console.log( error )
						}
					})
				}).catch( error =>{
					let msg = 'Error al consultar nómina'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}).finally( () => { this.cargar = false })
			},

			misComisiones( ){
				this.encargadascomisiones = [];
      this.overlay = true;

      const payload = {
        fecha: this.fecha,
        id_usuario: this.getdatosUsuarioERPERP.iderp,
      }

      this.$http
        .post("encargadas_comisiones.get.comisionesindividuales", payload)
        .then((response) => {
          this.encargadascomisiones = response.data;
          this.overlay = false;
          // this.getComisionesRetenidasIndividuales()
        })
        .catch((error) => {
          // INdicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
			},

			getNominaSemanal () {
				this.cargar = true

				const payload = {
					fecha:    this.fecha,   
				}

				return this.$http.post('encargadas_comisiones.get.nominasemanal', payload).then(response=>{
					this.nominaSemanal = response.data;
					this.cargar      = false  
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			save ( valor ) {
				this.cargar = true
				const payload = {
					id_usuario: this.getdatosUsuarioERPERP.id_trabajador,  
					estatus   : valor,
					id_ciclo  : this.ciclo.id_ciclo,
					semana    : this.selectedHeaders,
					motivo    : valor == 2 ? this.motivo : ''
				}


				this.$http.post('encargadas_comisiones.estatus.nomina', payload).then(response=>{
					this.validarSuccess('Datos grabados correctamente')
					this.rechazado = false
					this.motivo    = ''
					this.cargar = false
					this.initialize( )
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })	
			},

			updateNominaSemanal () {
				this.cargar = true
				const payload = {
					fecha: this.fecha,  
					data: this.filterEntradas
				}

				this.$http.post('encargadas_comisiones.update.nominasemanal', payload).then(response=>{
					this.validarSuccess('Datos grabados correctamente')
					this.dialogActualizar = false
					this.getNominaSemanal()
					this.initialize();
					this.cargar = false
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })	
			},

			handleClick() {
				this.dialogAceptar = true;
			},


			getAutorizarNomina() {
				this.autorizarNomina = [];
				this.overlay = true;

				const payload = {
					fecha: this.fecha
				}

				this.$http
				.post("encargadas_comisiones.get.autorizarnomina", payload)
				.then((response) => {
					this.autorizarNomina = response.data.respuesta;
					this.overlay = false;
				})
				.catch((error) => {
					// INdicamos que hay un error en el back
					if (error.body.message) {
						this.error = error.body.message;
					} else {
						this.error = error.body;
					}
					this.errorBack = true;
					this.overlay = false;
					this.dialogError = true;
				});
			},

			mostrarAsistencias(item){
				if( this.esRegistroHistorial(item) || !item.entradas ) return

				this.dialogAsistencias = true

				for (const i in item.entradas){
					this.asistencias.push({
						chequeo_entrada: item.entradas[i],
						chequeo_salida: item.salidas[i],
						hora_regular: item.hora_regular[i],
						hora_extra: item.hora_extra[i],
						hora_negativa: item.hora_negativa[i],
						hora_entrada: i == 0 ? item.horario_ingreso_fin : item.horario_ingreso,
						hora_salida: i == 0 ? item.horario_salida_fin : item.horario_salida,
					})
				}
			},

			formulaMontoLaborado(item) {
				if( this.esRegistroHistorial(item) ){
					this.formula_monto_laborado = `Monto registrado: ${item.monto_laborado}\n\nEl desglose diario no está disponible en nómina histórica.`
					return
				}

				console.log( item )

				const Hora1 = "08:17:40";
				const Hora2 = "08:00:00";
				const toleranceMinutes = 6;

				let lunes     = item.dias_no_completos.includes( 'Monday' )
				let martes    = item.dias_no_completos.includes( 'Tuesday' )
				let miercoles = item.dias_no_completos.includes( 'Wednesday' )
				let jueves    = item.dias_no_completos.includes( 'Thursday' )
				let viernes   = item.dias_no_completos.includes( 'Friday' )
				let sabado    = item.dias_no_completos.includes( 'Saturday' )
				let domingo   = item.dias_no_completos.includes( 'Sunday' )



				// console.log( Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, y Sunday ) ;

				let sueldo_dia = item.sueldo_dia;
				let dia_laboral = item.dia_laboral;
				this.formula_monto_laborado = `$${sueldo_dia}  X  ${dia_laboral} dias\n
				Días laborados:\n
				Sábado: 
				${ item.dia_descanso == 1    ? 'Descanso' : !item.entrada1 ? 'Sin registro' : item.entrada1 + ' a ' + item.salida1   } 
				${ item.entrada1 && item.salida1 ? item.estatus1 == 0 ? 'JORNADA COMPLETA' : item.estatus1 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus1 == 2 ? '' : sabado ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Domingo: 
				${ item.dia_descanso == 2   ? 'Descanso' : !item.entrada2 ? 'Sin registro' : item.entrada2 + ' a ' + item.salida2   } 
				${ item.entrada2 && item.salida2 ? item.estatus2 == 0 ? 'JORNADA COMPLETA' : item.estatus2 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus2 == 2 ? '' : domingo ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Lunes: 
				${ item.dia_descanso == 3     ? 'Descanso' : !item.entrada3 ? 'Sin registro' : item.entrada3 + ' a ' + item.salida3   } 
				${ item.entrada3 && item.salida3 ? item.estatus3 == 0 ? 'JORNADA COMPLETA' : item.estatus3 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus3 == 2 ? '' : lunes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Martes: 
				${ item.dia_descanso == 4    ? 'Descanso' : !item.entrada4 ? 'Sin registro' : item.entrada4 + ' a ' + item.salida4   } 
				${ item.entrada4 && item.salida4 ? item.estatus4 == 0 ? 'JORNADA COMPLETA' : item.estatus4 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus4 == 2 ? '' : martes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Miércoles: 
				${ item.dia_descanso == 5 ? 'Descanso' : !item.entrada5 ? 'Sin registro' : item.entrada5 + ' a ' + item.salida5   } 
				${ item.entrada5 && item.salida5 ? item.estatus5 == 0 ? 'JORNADA COMPLETA' : item.estatus5 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus5 == 2 ? '' : miercoles ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Jueves: 
				${ item.dia_descanso == 6    ? 'Descanso' : !item.entrada6 ? 'Sin registro' : item.entrada6 + ' a ' + item.salida6   } 
				${ item.entrada6 && item.salida6 ? item.estatus6 == 0 ? 'JORNADA COMPLETA' : item.estatus6 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus6 == 2 ? '' : jueves ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
				Viernes: 
				${ item.dia_descanso == 7   ? 'Descanso' : !item.entrada7 ? 'Sin registro' : item.entrada7 + ' a ' + item.salida7   } 
				${ item.entrada7 && item.salida7 ? item.estatus7 == 0 ? 'JORNADA COMPLETA' : item.estatus7 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO' : item.estatus7 == 2 ? '' : viernes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n`;
			},   

			formulaMontoHorasExtras(item) {
				if( this.esRegistroHistorial(item) ){
					this.formula_horas_extras = `Monto registrado: ${item.monto_horas_extras}\n\nEl desglose de horas no está disponible en nómina histórica.`
					return
				}

				let sueldo_hora = item.sueldo_hora;
				let cantidad_horas = item.cantidad_horas;
				this.formula_horas_extras = `${sueldo_hora}  X  ${ cantidad_horas ? cantidad_horas : 0 } horas extras`;
			},  

			formulaMontoRebajes(item) {
				if( this.esRegistroHistorial(item) ){
					this.formula_monto_rebajes = `Monto registrado: ${item.monto_total_rebajes}\n\nEl desglose de rebajes no está disponible en nómina histórica.`
					this.rebajesDetalleItems = []
					return
				}

				var rebajes = item.rebajes !== undefined && item.rebajes !== null ? item.rebajes : 0.00;
				var seguroIMSS = item.seguroIMSS !== undefined && item.seguroIMSS !== null ? item.seguroIMSS : 0.00;
				var cajaAhorro = item.cajaAhorro !== undefined && item.cajaAhorro !== null ? item.cajaAhorro : 0.00;
				var monto_retardo = item.monto_retardo !== undefined && item.monto_retardo !== null ? item.monto_retardo : 0.00;
				var retensiones = item.retensiones !== undefined && item.retensiones !== null ? item.retensiones : 0.00;
				var devoluciones = item.devoluciones !== undefined && item.devoluciones !== null ? item.devoluciones : 0.00;

				var subItems = [];
				if (monto_retardo && item.fechas) {
					if (item.estatus1 == 1 && item.fechas[0]) subItems.push({ fecha: this.formatFecha(item.fechas[0]), entrada: item.entrada1 || '-' });
					if (item.estatus2 == 1 && item.fechas[1]) subItems.push({ fecha: this.formatFecha(item.fechas[1]), entrada: item.entrada2 || '-' });
					if (item.estatus3 == 1 && item.fechas[2]) subItems.push({ fecha: this.formatFecha(item.fechas[2]), entrada: item.entrada3 || '-' });
					if (item.estatus4 == 1 && item.fechas[3]) subItems.push({ fecha: this.formatFecha(item.fechas[3]), entrada: item.entrada4 || '-' });
					if (item.estatus5 == 1 && item.fechas[4]) subItems.push({ fecha: this.formatFecha(item.fechas[4]), entrada: item.entrada5 || '-' });
					if (item.estatus6 == 1 && item.fechas[5]) subItems.push({ fecha: this.formatFecha(item.fechas[5]), entrada: item.entrada6 || '-' });
					if (item.estatus7 == 1 && item.fechas[6]) subItems.push({ fecha: this.formatFecha(item.fechas[6]), entrada: item.entrada7 || '-' });
				}

				var rebajesDetalle = item.rebajes_detalle && Array.isArray(item.rebajes_detalle) ? item.rebajes_detalle : (item.rebajes_detalle ? [item.rebajes_detalle] : []);

				this.rebajesDetalleItems = [
					{ id: 'retardo', label: 'Monto Retardo', valor: this.formatMonto(monto_retardo), icon: 'mdi-clock-alert-outline', iconColor: 'orange', subItems: subItems },
					{ id: 'rebajes', label: 'Monto Otros (Rebajes)', valor: this.formatMonto(rebajes), icon: 'mdi-cash-minus', iconColor: 'grey darken-2', detalleItems: rebajesDetalle },
					{ id: 'imss', label: 'Seguro IMSS', valor: this.formatMonto(seguroIMSS), icon: 'mdi-shield-account', iconColor: 'blue' },
					{ id: 'devoluciones', label: 'Devoluciones', valor: this.formatMonto(devoluciones), icon: 'mdi-cash-refund', iconColor: 'red' },
					{ id: 'caja', label: 'Caja de Ahorro', valor: this.formatMonto(cajaAhorro), icon: 'mdi-piggy-bank-outline', iconColor: 'green' },
					{ id: 'retenciones', label: 'Retenciones', valor: this.formatMonto(retensiones), icon: 'mdi-bank-transfer-out', iconColor: 'purple' }
				];
				this.rebajesExpandidos = {};
			},
			toggleRebajeDetalle(id) {
				this.rebajesExpandidos[id] = !this.rebajesExpandidos[id];
				this.$forceUpdate();
			},

			formatMonto(val) {
				var n = parseFloat(val);
				return isNaN(n) ? '0.00' : n.toFixed(2);
			},

			formulaMontoBonos(item) {
				if (!item) {
					this.bonosDetalleItems = []
					this.formula_monto_bonos = ''
					return
				}

				const ventas = this.parseMontoBonos(item.bonos_ventas)
				const ri = this.parseMontoBonos(item.bonos_ri)
				const puntualidad = this.parseMontoBonos(item.bonos_puntualidad)
				const prima = this.parseMontoBonos(item.prima_vacacional)
				const compensaciones = this.parseMontoBonos(item.compensaciones)
				const totalCalc = ventas + ri + puntualidad + prima + compensaciones
				const totalCampo = this.parseMontoBonos(item.monto_total_bonos)
				const total = totalCampo > 0 ? totalCampo : totalCalc

				this.bonosDetalleItems = [
					{
						label: 'Bonos Ventas',
						hint: 'Mejor vendedora / NI',
						valor: ventas,
						icon: 'mdi-trophy-outline',
						iconColor: 'amber darken-2',
					},
					{
						label: 'Bonos RI',
						hint: 'Reinscripciones',
						valor: ri,
						icon: 'mdi-account-multiple-plus-outline',
						iconColor: 'blue darken-1',
					},
					{
						label: 'Bonos Puntualidad',
						hint: 'PYA',
						valor: puntualidad,
						icon: 'mdi-clock-check-outline',
						iconColor: 'teal darken-1',
					},
					{
						label: 'Prima Vacacional',
						hint: 'Vacaciones aceptadas (jefe + RH)',
						valor: prima,
						icon: 'mdi-beach',
						iconColor: 'green darken-1',
					},
					{
						label: 'Compensaciones',
						hint: 'Otros bonos / compensaciones',
						valor: compensaciones,
						icon: 'mdi-cash-plus',
						iconColor: 'indigo darken-1',
					},
					{
						label: 'Total bonos',
						hint: '',
						valor: total,
						icon: 'mdi-sigma',
						iconColor: 'success',
						esTotal: true,
					},
				]

				this.formula_monto_bonos =
					'Ventas + RI + Puntualidad + Prima Vacacional + Compensaciones = ' +
					this.formatMoneyBonos(total)
			},

			formulaMontoTotal(item) {
				let monto_laborado = item.monto_laborado !== undefined && item.monto_laborado !== null ? item.monto_laborado : 0.00;
				let compensaciones = item.compensaciones !== undefined && item.compensaciones !== null ? item.compensaciones : 0.00;
				let monto_horas_extras = item.monto_horas_extras !== undefined && item.monto_horas_extras !== null ? item.monto_horas_extras : 0.00;
				let comisiones_semana = item.comisiones_semana !== undefined && item.comisiones_semana !== null ? item.comisiones_semana : 0.00;
				let monto_total_rebajes = item.monto_total_rebajes !== undefined && item.monto_total_rebajes !== null ? item.monto_total_rebajes : 0.00;
				let monto_total_bonos = item.monto_total_bonos !== undefined && item.monto_total_bonos !== null ? item.monto_total_bonos : 0.00;

				this.formula_monto_total = `
				Monto Jornada Laboral: ${monto_laborado}\n  
				Monto Compensaciones: ${compensaciones}\n  
				Monto Horas Extras: ${monto_horas_extras}\n  
				Monto Comisiones: ${comisiones_semana}\n  
				Monto Bonos: ${monto_total_bonos}\n  
				Monto Rebajes: ${monto_total_rebajes} 
				`;
			},

			formatFecha( fechadata ){
				// Fecha en formato 'YYYY-MM-DD'
				let fechaString = fechadata;

				// Dividir la cadena de fecha en componentes
				let [year, month, day] = fechaString.split('-').map(Number);

				// Crear un objeto Date con los componentes (mes en JavaScript es 0-indexed)
				let fecha = new Date(year, month - 1, day);

				// Array de días de la semana y meses del año
				let diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
				let meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

				// Obtener el día de la semana, día del mes y mes
				let diaSemana = diasSemana[fecha.getDay()];
				let dia = fecha.getDate();
				let mes = meses[fecha.getMonth()];

				// Construir la cadena en el formato deseado
				return `${diaSemana} ${dia} de ${mes}`;
			},

			getCiclosFecha () {
				this.cargarCiclos()
			},

			async cargarCiclos(){
				this._configurandoFiltros = true
				this.ciclos = []

				try{
					const response = await this.$http.post('roles.get.ciclos.minomina', { fecha: this.fecha })
					this.ciclos = response.data.ciclos || []

					const cicloActual = response.data.ciclo_actual
					if( cicloActual ){
						this.ciclo = this.ciclos.find(el => el.id_ciclo === cicloActual.id_ciclo) || cicloActual
					}else if( this.ciclos.length ){
						this.ciclo = this.ciclos.find(el => {
							const inicio = el.fecha_inicio_ciclo.substr(0, 10)
							const fin = el.fecha_fin_ciclo.substr(0, 10)
							return this.fecha >= inicio && this.fecha <= fin
						}) || this.ciclos[0]
					}

					if( this.ciclo ){
						this.actualizarSemanas()
					}
				}catch( error ){
					let msg = 'Error al cargar ciclos'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this._configurandoFiltros = false
					if( this.ciclo && this.selectedHeaders ){
						this.initialize()
					}
				}
			},

			goHorasExtras( name ){
				this.$router.push({name: "HorasExtras", params: { fecha: this.fecha, nombre: name }})
			},
			goPrenomina( name ){
				this.$router.push({name: "EntradasSalidas", params: { fecha: this.fecha, nombre: name } })
			},
			goBonos( name ){
				this.$router.push({name: "BonosVentas", params: { fecha: this.fecha, nombre: name }})
			},
			goRebajes( name ){
				this.$router.push({name: "RebajesNomina", params: { fecha: this.fecha, nombre: name }})
			},
			goComisiones( name ){
				this.$router.push({name: "EncargadasComisiones", params: { fecha: this.fecha, nombre: name }})
			},

			exportExcel(data) {
				const wb = XLSX.utils.book_new();
				data.forEach(sheetData => {
					const ws = XLSX.utils.json_to_sheet(sheetData.data);
					XLSX.utils.book_append_sheet(wb, ws, sheetData.sheetName);
				});

				// Descarga el archivo Excel
				XLSX.writeFile(wb, 'Nomina y Prenomina.xlsx');
			},

			exportarInscripciones() {
				// const empleados = this.filterEntradas.map(({ id, nombre_completo, puesto, departamento, plantel, tipo_pago, sueldo_mensual, sueldo_semanal, sueldo_dia, sueldo_hora, dia_laboral, horas_laboradas_total, cantidad_horas, monto_horas_extras, retardos, comisiones_semana, devoluciones, rebajes, monto_retardo,  retensiones, compensaciones, bonos_ventas, bonos_ri, bonos_puntualidad, seguroIMSS, cajaAhorro, monto_laborado, monto_total }) =>
				// 	({ id, nombre_completo, puesto, departamento, plantel, tipo_pago, sueldo_mensual, sueldo_semanal, sueldo_dia, sueldo_hora, dia_laboral, horas_laboradas_total, "Horas Extras": cantidad_horas, monto_horas_extras, retardos, comisiones_semana, devoluciones, rebajes, monto_retardo, retensiones, compensaciones, bonos_ventas, bonos_ri, bonos_puntualidad, seguroIMSS, cajaAhorro, monto_laborado, monto_total }));

				const empleados = this.filterEntradas.map(({ id, nombre_completo, puesto, monto_laborado, monto_horas_extras, comisiones_semana, monto_total_rebajes, monto_total_bonos, monto_total }) =>
					({ "ID": id,"Empleado":nombre_completo, "Puesto":puesto, "Monto Jornada Laboral":monto_laborado,  "Monto Horas Extras":monto_horas_extras,  "Monto Comisiones":comisiones_semana, "Monto Rebajes":monto_total_rebajes, "Monto Bonos":monto_total_bonos,  "Monto Total":monto_total }));

				const empleados2 = this.filterEntradas.map(({ id, nombre_completo, puesto, plantel, sucursal_registro, fecha_ingreso, dia_laboral, horas_laboradas_total, horas_extras, entrada1, salida1, horas_laboradas1,  entrada2, salida2, horas_laboradas2, entrada3, salida3, horas_laboradas3,  entrada4, salida4, horas_laboradas4,  entrada5, salida5, horas_laboradas5,  entrada6, salida6, horas_laboradas6, entrada7, salida7, horas_laboradas7 }) => 
					({ id, nombre_completo, puesto, plantel, sucursal_registro, fecha_ingreso, dia_laboral, horas_laboradas_total, horas_extras, "Sabado/Entrada": entrada1, "Sabado/Salida":salida1, "Sabado/Horas":horas_laboradas1,  "Domingo/Entrada":entrada2, "Domingo/Salida":salida2, "Domingo/Horas":horas_laboradas2,  "Lunes/Entrada":entrada3, "Lunes/Salida":salida3, "Lunes/Horas":horas_laboradas3,  "Martes/Entrada":entrada4, "Martes/Salida":salida4, "Martes/Horas":horas_laboradas4, "Miercoles/Entrada":entrada5, "Miercoles/Salida":salida5, "Miercoles/Horas":horas_laboradas5, "Jueves/Entrada":entrada6, "Jueves/Salida":salida6, "Jueves/Horas":horas_laboradas6, "Viernes/Entrada":entrada7, "Viernes/Salida":salida7, "Viernes/Horas":horas_laboradas7  }));

				const empleados3 = this.nomina_pasada.map(({ id_trabajador, empleado, puesto, plantel, monto_total_sin_comisiones, monto_total_actual, monto_total_diferencia}) => 
					({ id_trabajador, empleado, puesto, plantel, "Monto Anterior": monto_total_sin_comisiones, "Monto Actual": monto_total_actual, "Monto Diferencia": monto_total_diferencia }));

				const empleados4 = this.filterEntradasEncargadas.map(({ id, nombre_completo, puesto, plantel, comisiones_semana}) => 
					({ id, nombre_completo, puesto, plantel, "Comisiones": comisiones_semana }));


				// Llama a la función exportExcel para crear un archivo Excel con dos pestañas
				this.exportExcel([
					{ sheetName: 'Nomina', data: empleados },
					{ sheetName: 'Prenomina', data: empleados2 }, // Segunda pestaña con los mismos datos
					{ sheetName: 'Comparativa', data: empleados3 }, // Segunda pestaña con los mismos datos
					{ sheetName: 'Comisiones', data: empleados4 } // Segunda pestaña con los mismos datos
				]);
			},

			async subirRequi( ){

				await this.subirNominaINBI()
				await this.subirComisionesINBI()
				await this.subirNominaFAST()
				await this.subirComisionesFAST()

			},

			async subirNominaINBI( ){

				let nominaInbiOperaciones = this.filterEntradas.filter( el => el.departamento == 'Operaciones' && !el.plantel.match('FAST') )

				let detallesInbiOperaciones = []

				for( const i in nominaInbiOperaciones ){

					const { id_usuario, monto_laborado, nombre_completo, id_plantel } = nominaInbiOperaciones[i]

					detallesInbiOperaciones.push({
						id_elemento_requisicion: 17,
						id_plantel_resultados: id_plantel,
						id_plantel: id_plantel,
						concepto: nombre_completo,
						cantidad: 1,
						costo_unitario: monto_laborado.replace('$',''),
						costo_total: monto_laborado.replace('$',''),
						id_alumno: 0,
						id_grupo: 0,
						id_empleado: id_usuario
					})
				}

				var payload = {
      		registro:                      null,
      		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
		      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
		      id_requisicion_compra_estatus: 1,
		      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
		      id_usuario_compra:             28,
		      tipo_requisicion:              1,
		      id_ciclo:                      this.ciclo.id_ciclo,
          id_proyecto:                   null,
		      comentarios:                   'Nómina',
		      detalles:                      detallesInbiOperaciones,
			    fotos:[]
	      }


	      return this.$http.post('generar.nomina.operaciones', payload ).then(response=>{
          this.validarSuccess( 'Requisición generada correctamente' )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

			},

			async subirNominaFAST( ){

				let nominaInbiOperaciones = this.filterEntradas.filter( el => el.departamento == 'Operaciones' && el.plantel.match('FAST') )

				let detallesInbiOperaciones = []

				for( const i in nominaInbiOperaciones ){

					const { id_usuario, monto_laborado, nombre_completo, id_plantel } = nominaInbiOperaciones[i]

					detallesInbiOperaciones.push({
						id_elemento_requisicion: 17,
						id_plantel_resultados: id_plantel,
						id_plantel: id_plantel,
						concepto: nombre_completo,
						cantidad: 1,
						costo_unitario: monto_laborado.replace('$',''),
						costo_total: monto_laborado.replace('$',''),
						id_alumno: 0,
						id_grupo: 0,
						id_empleado: id_usuario
					})
				}

				var payload = {
      		registro:                      null,
      		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
		      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
		      id_requisicion_compra_estatus: 1,
		      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
		      id_usuario_compra:             28,
		      tipo_requisicion:              1,
		      id_ciclo:                      this.ciclo.id_ciclo_relacionado,
          id_proyecto:                   null,
		      comentarios:                   'Nómina',
		      detalles:                      detallesInbiOperaciones,
			    fotos:[]
	      }


	      return this.$http.post('generar.nomina.operaciones', payload ).then(response=>{
          this.validarSuccess( 'Requisición generada correctamente' )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

			},

			async subirComisionesINBI( ){

				let nominaInbiOperaciones = this.filterEntradas.filter( el => el.departamento == 'Operaciones' && !el.plantel.match('FAST') )

				let detallesInbiOperaciones = []

				for( const i in nominaInbiOperaciones ){

					const { id_usuario, comisiones_semana, nombre_completo, id_plantel } = nominaInbiOperaciones[i]

					detallesInbiOperaciones.push({
						id_elemento_requisicion: 17,
						id_plantel_resultados: id_plantel,
						id_plantel: id_plantel,
						concepto: nombre_completo + ' ( COMISIONES )',
						cantidad: 1,
						costo_unitario: comisiones_semana.replace('$',''),
						costo_total: comisiones_semana.replace('$',''),
						id_alumno: 0,
						id_grupo: 0,
						id_empleado: id_usuario
					})
				}

				var payload = {
      		registro:                      null,
      		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
		      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
		      id_requisicion_compra_estatus: 1,
		      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
		      id_usuario_compra:             28,
		      tipo_requisicion:              1,
		      id_ciclo:                      this.ciclo.id_ciclo,
          id_proyecto:                   null,
		      comentarios:                   'Nómina',
		      detalles:                      detallesInbiOperaciones,
			    fotos:[]
	      }


	      return this.$http.post('generar.nomina.operaciones', payload ).then(response=>{
          this.validarSuccess( 'Requisición generada correctamente' )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

			},

			async subirComisionesFAST( ){

				let nominaInbiOperaciones = this.filterEntradas.filter( el => el.departamento == 'Operaciones' && el.plantel.match('FAST') )

				let detallesInbiOperaciones = []

				for( const i in nominaInbiOperaciones ){

					const { id_usuario, comisiones_semana, nombre_completo, id_plantel } = nominaInbiOperaciones[i]

					detallesInbiOperaciones.push({
						id_elemento_requisicion: 17,
						id_plantel_resultados: id_plantel,
						id_plantel: id_plantel,
						concepto: nombre_completo + ' ( COMISIONES )',
						cantidad: 1,
						costo_unitario: comisiones_semana.replace('$',''),
						costo_total: comisiones_semana.replace('$',''),
						id_alumno: 0,
						id_grupo: 0,
						id_empleado: id_usuario
					})
				}

				var payload = {
      		registro:                      null,
      		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
		      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
		      id_requisicion_compra_estatus: 1,
		      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
		      id_usuario_compra:             28,
		      tipo_requisicion:              1,
		      id_ciclo:                      this.ciclo.id_ciclo_relacionado,
          id_proyecto:                   null,
		      comentarios:                   'Nómina',
		      detalles:                      detallesInbiOperaciones,
			    fotos:[]
	      }


	      return this.$http.post('generar.nomina.operaciones', payload ).then(response=>{
          this.validarSuccess( 'Requisición generada correctamente' )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

			},


			parseTimeString(timeString) {
			  const [hours, minutes, seconds] = timeString.split(':').map(Number);
			  return new Date(1970, 0, 1, hours, minutes, seconds);
			},

			checkArrivalTime(hora1, hora2, toleranceMinutes) {
			  const date1 = this.parseTimeString(hora1);
			  const date2 = this.parseTimeString(hora2);

			  const diffInMs = date1 - date2; // Difference in milliseconds
			  const diffInMinutes = diffInMs / 1000 / 60; // Convert to minutes

			  if (diffInMinutes <= toleranceMinutes) {
			    return "Llegó a tiempo";
			  } else {
			    return "Llegó tarde";
			  }
			},

			getDiaDescando( dia ){

				switch( dia ){

					case 1: 
						return 'Sábado' 
					break; 

					case 2: 
						return 'Domingo' 
					break; 

					case 3: 
						return 'Lunes' 
					break; 

					case 4: 
						return 'Martes' 
					break; 

					case 5: 
						return 'Miércoles' 
					break; 

					case 6: 
						return 'Jueves' 
					break; 

					case 7: 
						return 'Viernes' 
					break; 

				}

			},

			format( valor ){
			  return valor.toLocaleString('es-MX', {
			    style: 'currency',
			    currency: 'MXN'
			  });
      }

		},
	}
</script>




